export const TAGS = (t) => [
    { id: 'categories', label: t('discover.algo_comparision.tabs.categories') },
    { id: 'entities', label: t('discover.algo_comparision.tabs.entities') },
    { id: 'authors', label: t('discover.algo_comparision.tabs.authors') },
];
